module.exports = __webpack_public_path__ + "img/wmdyw_bg.20ebcb25.png";